import { render, staticRenderFns } from "./EmailProductPromotionDialog.vue?vue&type=template&id=26d7e090"
import script from "./EmailProductPromotionDialog.vue?vue&type=script&lang=js"
export * from "./EmailProductPromotionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports